export const translations = {
  "en-US": require("./../public/en-US.json"),
  "fr-CA": require("./../public/fr-CA.json"),  
};
